export default __webpack_public_path__ + "static/media/Zogniskowane wywiady grupowe_Instrukcja.8d846225.pdf";